import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  inputWrapper: {
    position: "relative",
    marginTop: "24px",
  },
  realInput: {
    width: "100%",
    padding: "8px 12px",
    fontSize: "14px",
    boxSizing: "border-box",
    border: "1px solid #939393",
    borderRadius: "6px",
    height: "36px",
    outline: "none",
  },
  customPlaceholder: {
    position: "absolute",
    top: "8px",
    left: "12px",
    right: "12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    pointerEvents: "none",
    color: "#aaa",
    fontSize: "14px",
  },
  rightPlaceholder: {
    fontWeight: 400,
    fontSize: "12px",
    fontStyle: "italic",
  },
  hidden: {
    display: "none",
  },
  spinnerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "20px",
  },
}));
